
import {ValidationObserver} from 'vee-validate';
import {Component, Prop, Vue} from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;

@Component({
  name: 'offer-checkout',
  components: {
    ValidationObserver,
    OfferSummary: require('../offer/Summary.vue').default,
    CheckoutAddressDetail: require('../step/AddressDetail.vue').default,
    CheckoutPaymentAgreement: require('../step/Agreement.vue').default,
  },
})
export default class extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  @Prop({required: false}) private mergeMessage: string;
  @Prop({default: false}) private isLoggedIn: boolean;
  @Prop({default: null}) private customerEmail: string;
  @Prop({default: []}) private addresses: Array<object>;
  @Prop({default: null}) private countries: Array<object>;
  @Prop({default: null}) private errorMessage: string | null;
  @Prop({default: false}) private isB2b: boolean;

  protected loadingCheckout: boolean = false;
  protected checkoutErrorMessage: TranslateResult = '';
  protected customerNote: string = '';

  private get showLoginForm(): boolean {
    return this.$store.getters['CheckoutGlobal/showLoginForm'];
  }

  private get currentStep(): number {
    return this.$store.getters['CheckoutGlobal/currentStep'];
  }

  private async mounted(): Promise<void> {
    await this.$store.dispatch('CheckoutTotals/fetchCartTotals');

    if (0 === this.$store.getters['CheckoutTotals/cartTotals']['extension_attributes']['valid_stock']) {
      window.location.href = '/checkout/cart';
    }

    if (this.isLoggedIn && this.customerEmail) {
      this.$store.commit('CheckoutGlobal/SET_CUSTOMER_EMAIL', this.customerEmail);
    }
     this.$store.commit('CheckoutGlobal/SET_IS_BUSINESS_ACCOUNT', this.isB2b ? true : false);
  }

  private goToStep(step): void {
    if (step === this.currentStep || this.showLoginForm) {
      return;
    }

    if (step - this.currentStep > 1) {
      step = this.currentStep + 1;
    }

    this.$refs.form.validate().then((result) => {
      if (this.isLoggedIn && step === 2) {
        this.setShippingAndBillingAddresses();
      }
        if (result || step < this.currentStep) {
        this.$store.dispatch('CheckoutGlobal/gotoStep', step);
        window.scrollTo(0, 0);
      } else {
        if (this.currentStep === 1) {
          const failedInputElements = document.querySelectorAll('input.failed');
          Array.from(failedInputElements).forEach((el, index) => {
            if (index === 0) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'start',
              });
            }
            el.classList.add('--shake');
          });
        }
      }
    });
  }

  private async validatedPlaceOffer(): Promise<void> {
    this.$refs.form.validate().then(() => {
      const failedInputElements = document.querySelectorAll('input.failed');
      Array.from(failedInputElements).forEach((el, index) => {
        if (index === 0) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start',
          });
        }
        el.classList.add('--shake');
      });

      if (failedInputElements.length > 0) {
        return;
      }

      return this.placeOffer();
    });
  }

  private async placeOffer(): Promise<void> {
    try {
      this.loadingCheckout = true;

      const { data } = await this.$solarClient.post('/api/custom/checkout/offer/complete', {
        customer_note: this.customerNote,
      });

      if (data.redirect) {
        window.location.assign(data.redirect);
      } else if (data.error) {
        this.checkoutErrorMessage = data.error;
        window.scrollTo(0, 0);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        this.checkoutErrorMessage = error.response.data.error;
      } else {
        this.checkoutErrorMessage = this.$t('There was an error completing your offer. Please try again later.');
      }
      window.scrollTo(0, 0);
    } finally {
      this.loadingCheckout = false;
    }
  }

  private async setShippingAndBillingAddresses() {
    await this.$store.dispatch('CheckoutShipping/setShippingMethod', {
      method_code: 'freeshipping',
      carrier_code: 'freeshipping',
    });

    try {
      await this.$store.dispatch('CheckoutPayment/collectPaymentMethods');
    } catch (error) {
      console.error('Error collecting payment methods:', error);
    }
  }
}
